export enum LinkSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum LinkTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
